import CustomFilePlayer from "../../../../cap17drive/squadflixVideoView/customFilePlayer/customFilePlayer";
import {useEffect, useMemo, useRef, useState} from "react";
import './squadflix-tv-player.scss';
import SocketUtils, {useSocketEvents} from "../../socket-utils/socketUtils";

const SquadflixTvPlayer = ({video, deviceInfo, connected}) => {

    const filePlayerRef = useRef();
    const [loading, setLoading] = useState(false);

    const videoUrlRef = useRef(null);

    useEffect(() => {
        if (video && video.videoUrl) {
            if (video.videoUrl !== videoUrlRef.current) {
                videoUrlRef.current = video.videoUrl;
                setLoading(true);
                setTimeout(() => {
                    setLoading(false)
                }, 100);
            }
        }
    }, [video]);


    const events = useMemo(() => ({
        forward_time: (data) => {
            if (filePlayerRef.current && data.time) {
                filePlayerRef.current.forward(data.time);
            }
        },
        stop_video: () => {
        },
        resume_video: () => {
            filePlayerRef.current?.play();
        },
        pause_video: () => {
            filePlayerRef.current?.pause();
        },
        select_subtitle: (data) => {
            filePlayerRef.current?.selectSubtitle(data.subtitle);
        },
        change_track: (data) => {
            filePlayerRef.current?.selectAudioTrack(data.trackIndex);
        },
        select_video_type: (data) => {
            filePlayerRef.current?.changeVideoType(data.type);
        }
    }), []);
    useSocketEvents({connected, events});


    const onStatusChange = (status) => {
        SocketUtils.emit("player_status_change", {status, device: deviceInfo});
    }

    if (loading) {
        return null;
    }

    return (<div className="squadflix-tv-player">
        <div className="squadflix-tv-player__player">
            <CustomFilePlayer ref={filePlayerRef} title={video.title} subtitles={video.subtitles}
                              audios={video.audios} videoUrl={video.streamingVideoUrl}
                              customRuntime={video.runtime} downloadInfo={video.downloadInfo}
                              streaming={video.streaming} item={video.item} originalVideoUrl={video.videoUrl}
                              squadFlixTvHook={undefined} onGoNextEpisode={undefined}
                              onClosePlayer={undefined} onStatusChange={onStatusChange}/>
        </div>
    </div>);
}

export default SquadflixTvPlayer;
